import { render, staticRenderFns } from "./ContinueRegister.vue?vue&type=template&id=51964ac0&scoped=true&"
import script from "./ContinueRegister.vue?vue&type=script&lang=js&"
export * from "./ContinueRegister.vue?vue&type=script&lang=js&"
import style0 from "./ContinueRegister.vue?vue&type=style&index=0&id=51964ac0&prod&lang=css&"
import style1 from "./ContinueRegister.vue?vue&type=style&index=1&id=51964ac0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51964ac0",
  null
  
)

export default component.exports